import React, { useState } from 'react';

const Image = ({ ...rest }) => {
  const [height, setHeight] = useState(0)

  const onLoad = (event) => {
    const { target: { naturalHeight, naturalWidth }} = event;
    setHeight(naturalHeight * 188 / naturalWidth);
  }
  return <img onLoad={onLoad} { ...rest } style={{ width: '188px', height }}/>
}

export default Image;
